var _ActionsManager_actions;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
export class ActionsManager {
    constructor(actions) {
        _ActionsManager_actions.set(this, void 0);
        __classPrivateFieldSet(this, _ActionsManager_actions, actions !== null && actions !== void 0 ? actions : {}, "f");
    }
    get actions() {
        return __classPrivateFieldGet(this, _ActionsManager_actions, "f");
    }
    action(actionName) {
        return __classPrivateFieldGet(this, _ActionsManager_actions, "f")[actionName];
    }
    setActions(actions) {
        __classPrivateFieldSet(this, _ActionsManager_actions, actions, "f");
        return this;
    }
}
_ActionsManager_actions = new WeakMap();
